import * as React from 'react';
import { USERNAME, LAST_NAME, DOB, POSTCODE } from 'ts/constants/UrlParams';
import { ERROR_CODES } from 'ts/passwordless-login/components/pages/error/ErrorCodes';
import { ErrorFlow } from 'ts/passwordless-login/components/pages/error/ErrorFlow';
import { navigateToErrorPage } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { Content } from 'ts/passwordless-login/components/pages/find-email/Interfaces';
import { findAccountForManualReg } from 'ts/services/find-account/FindAccountService';
import { getHashOrQueryParam } from 'ts/window/WindowUtils';
import { ROUTES } from '../../../../Routes';
import { FindEmailPage } from '../../pages/find-email/FindEmailPage';
import { getManualRegistrationUrl } from 'ts/config/ConfigService';
import { sendOtcAndRedirect } from './Actions';

interface ManualRegCustomerLookupPageProps {
  history: any;
}

const nextAction = (history: any) => async (username: string) => {
  sendOtcAndRedirect(history, username);
};

const conflictAccountAction = (history: any) => (
  lastName: string,
  dob: string,
  postcode: string,
) => {
  const username = getHashOrQueryParam(USERNAME);
  history.push({
    pathname: ROUTES.MANUAL_REG_ACCOUNT_NUMBER,
    search: `?${LAST_NAME}=${lastName}&${DOB}=${dob}&${POSTCODE}=${postcode}&${USERNAME}=${username}`,
  });
};

const errorPageAction = (history: any) => (statusCode: number) => {
  let errorCode;
  switch (statusCode) {
    case 422:
      errorCode = ERROR_CODES.MANUAL_REG_SAP_EMAIL_ERROR;
      break;
    case 424:
      errorCode = ERROR_CODES.MANUAL_REG_SAP_CREATE_ERROR;
      break;
    default:
      errorCode = ERROR_CODES.MANUAL_REG_3_POINT_CHECK;
      break;
  }
  navigateToErrorPage(errorCode, ErrorFlow.manualReg, '', history, true);
};

const findAccountAction = (lastName: string, dob: string, postcode: string) => {
  return findAccountForManualReg(lastName, dob, postcode);
};

const ManualRegCustomerLookupPage: React.FC<ManualRegCustomerLookupPageProps> = ({ history }) => {
  const content: Content = {
    analytics: {
      taskType: 'auth:manual-reg',
      navigation: {
        friendlyUri: 'originenergy:my-account:auth:manual-reg-verify',
      },
      errorForm: {
        formName: 'auth:manual-reg',
        errorMessage: 'auth:manual-reg:account-not-found',
        errorCode: 'account-not-found',
      },
    },
    copy: {
      headingText: "Let's find your email",
      infoText: `**${getHashOrQueryParam(
        USERNAME,
      )}** isn't in our address book. Let's get some extra details to verify who you are. If you're a business customer, [register here](${getManualRegistrationUrl()}).`,
      alertBoxText:
        "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](mailto:support@originenergy.com.au).",
    },
  };
  return (
    <FindEmailPage
      findAccountAction={findAccountAction}
      content={content}
      history={history}
      nextAction={nextAction(history)}
      conflictAccountAction={conflictAccountAction(history)}
      errorPageAction={errorPageAction(history)}
    />
  );
};

export { ManualRegCustomerLookupPage };
